/** Workspace 视口 ↔ 世界坐标换算（与 useCanvasViewport 一致） */

export function screenToWorld(
  clientX: number,
  clientY: number,
  viewportRect: DOMRect,
  panX: number,
  panY: number,
  zoom: number,
): { x: number; y: number } {
  return {
    x: (clientX - viewportRect.left - panX) / zoom,
    y: (clientY - viewportRect.top - panY) / zoom,
  };
}

export function worldToScreen(
  worldX: number,
  worldY: number,
  viewportRect: DOMRect,
  panX: number,
  panY: number,
  zoom: number,
): { x: number; y: number } {
  return {
    x: viewportRect.left + panX + worldX * zoom,
    y: viewportRect.top + panY + worldY * zoom,
  };
}

export function worldToPageLocal(
  worldX: number,
  worldY: number,
  pageX: number,
  pageY: number,
): { x: number; y: number } {
  return { x: worldX - pageX, y: worldY - pageY };
}

export function pageLocalToWorld(
  localX: number,
  localY: number,
  pageX: number,
  pageY: number,
): { x: number; y: number } {
  return { x: localX + pageX, y: localY + pageY };
}
